// Inline SVG logo for the app. Uses CSS variables --logo-text and
// --logo-mic so it adapts to light/dark themes with no JS. The
// design echoes the supplied "NVH Dictation Tool" PNG: serif "NVH"
// with a microphone integrated where the V's tip would be,
// "DICTATION TOOL" subtitle beneath, and a centred audio-waveform
// decoration. If the user later drops the original PNG at
// /logo.png, swap the <Logo /> tag for an
// <img src="/logo.png" alt="NVH Dictation Tool" /> — the wrapper
// class "app-logo" will style either correctly.

export function Logo({ height = 44 }: { height?: number }) {
  return (
    <svg
      className="app-logo"
      role="img"
      aria-label="NVH Dictation Tool"
      viewBox="0 0 280 90"
      height={height}
      width={(height * 280) / 90}
    >
      {/* "N" and "H" — black serif caps */}
      <text
        x="44"
        y="50"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontWeight="700"
        fontSize="54"
        fill="var(--logo-text)"
        letterSpacing="2"
      >
        N
      </text>
      <text
        x="200"
        y="50"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontWeight="700"
        fontSize="54"
        fill="var(--logo-text)"
        letterSpacing="2"
      >
        H
      </text>
      {/* Blue "V" with a microphone sitting at the apex */}
      <g fill="var(--logo-mic)">
        {/* Left arm of the V */}
        <path d="M104 12 L138 12 L150 50 L128 50 Z" />
        {/* Right arm of the V */}
        <path d="M128 50 L150 50 L172 12 L186 12 Z" />
        {/* Microphone body — capsule sitting just above the V's apex */}
        <rect x="138" y="2" width="24" height="32" rx="12" />
        {/* Mic stand stem dipping into the V */}
        <rect x="148" y="34" width="4" height="14" />
        {/* Mic basket cradle (curved line under the capsule) */}
        <path
          d="M132 30 a18 18 0 0 0 36 0"
          fill="none"
          stroke="var(--logo-mic)"
          strokeWidth="3"
        />
      </g>
      {/* "DICTATION TOOL" subtitle */}
      <text
        x="140"
        y="74"
        textAnchor="middle"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontWeight="700"
        fontSize="14"
        letterSpacing="4"
        fill="var(--logo-text)"
      >
        DICTATION TOOL
      </text>
      {/* Audio-waveform accent, centred under the subtitle */}
      <g fill="var(--logo-mic)">
        <rect x="100" y="83" width="2" height="4" />
        <rect x="106" y="81" width="2" height="8" />
        <rect x="112" y="78" width="2" height="14" />
        <rect x="118" y="75" width="2" height="20" />
        <rect x="124" y="80" width="2" height="10" />
        <rect x="130" y="77" width="2" height="16" />
        <rect x="136" y="74" width="2" height="22" />
        <rect x="142" y="76" width="2" height="18" />
        <rect x="148" y="79" width="2" height="12" />
        <rect x="154" y="76" width="2" height="18" />
        <rect x="160" y="80" width="2" height="10" />
        <rect x="166" y="83" width="2" height="4" />
        <rect x="172" y="80" width="2" height="10" />
        <rect x="178" y="82" width="2" height="6" />
      </g>
    </svg>
  );
}
